// // import React, { useEffect, useState } from 'react';
// // import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints';
// // import { Col, Form, Row } from 'react-bootstrap';
// // import { Typeahead } from 'react-bootstrap-typeahead';
// // import toast from 'react-hot-toast';

// // const StudentTC = () => {
// //   const [courses, setCourses] = useState([]);
// //   const [classes, setClasses] = useState([]);
// //   const [allStudents, setAllStudents] = useState([]);
// //   const [filteredStudents, setFilteredStudents] = useState([]);

// //   const [selectedCourseId, setSelectedCourseId] = useState(null);
// //   const [selectedClassId, setSelectedClassId] = useState(null);
// //   const [selectedStudent, setSelectedStudent] = useState(null);

// //   const [tcData, setTcData] = useState({
// //     serialNo: '93',
// //     date: new Date().toISOString().split('T')[0],
// //     studentName: '',
// //     fatherName: '',
// //     motherName: '',
// //     villageTown: '',
// //     district: 'Sonitpur',
// //     state: 'Assam',
// //     admissionDate: '',
// //     leavingDate: '',
// //     currentClass: '',
// //     nextClass: '',
// //     examType: '',
// //     examYear: '',
// //     examResult: 'passed',
// //     dob: '',
// //     conduct: 'satisfactory',
// //     reason: 'Unavoidable change of residence',
// //     place: 'Gopalpur, Jamugurihat'
// //   });

// //   // Fetch all courses
// //   useEffect(() => {
// //     ApiEndpoints.getAllCourses()
// //       .then(res => setCourses(res.data.data || []))
// //       .catch(console.error);
// //   }, []);

// //   // Fetch classes when course changes
// //   useEffect(() => {
// //     if (selectedCourseId) {
// //       ApiEndpoints.getAllClassesByCourseId(selectedCourseId)
// //         .then(res => setClasses(res.data.data || []))
// //         .catch(console.error);

// //       // Reset class and student selection
// //       setSelectedClassId(null);
// //       setSelectedStudent(null);
// //       setFilteredStudents([]);
// //     }
// //   }, [selectedCourseId]);

// //   // Fetch students when class changes
// //   useEffect(() => {
// //     if (selectedClassId) {
// //       ApiEndpoints.getStudentsByClassId(selectedClassId)
// //         .then(res => {
// //           const students = res.data.data || [];
// //           setAllStudents(students);
// //           setFilteredStudents(students);
// //         })
// //         .catch(console.error);

// //       setSelectedStudent(null);
// //     }
// //   }, [selectedClassId]);

// //   // Update TC data when student changes
// //   useEffect(() => {
// //     if (selectedStudent) {
// //       setTcData(prev => ({
// //         ...prev,
// //         studentName: selectedStudent.name,
// //         fatherName: selectedStudent.fatherName,
// //         motherName: selectedStudent.motherName,
// //         villageTown: selectedStudent.villageTown,
// //         district: selectedStudent.district || 'Sonitpur',
// //         state: selectedStudent.state || 'Assam',
// //         admissionDate: selectedStudent.admissionDate,
// //         leavingDate: selectedStudent.leavingDate,
// //         currentClass: selectedStudent.currentClass,
// //         nextClass: selectedStudent.nextClass,
// //         examType: selectedStudent.examType,
// //         examYear: selectedStudent.examYear,
// //         examResult: selectedStudent.examResult,
// //         dob: selectedStudent.dob,
// //         conduct: selectedStudent.conduct,
// //         reason: selectedStudent.reason,
// //         place: selectedStudent.place || 'Gopalpur, Jamugurihat'
// //       }));
// //     }
// //   }, [selectedStudent]);

// //     const handleClassChange = async (e) => {
// //     const classId = e.target.value
// //     setSelectedClassId(classId)
// //     setSelectedStudent(null)

// //     console.log('Selected Class ID:', classId)

// //     try {
// //       const payload = { class_id: parseInt(classId) }
// //       console.log('Fetching attendance with payload:', payload)

// //       const res = await ApiEndpoints.getAllStudents(payload)
// //       setAllStudents(res.status.data)
// //     } catch (error) {
// //       console.error(
// //         'Error fetching attendance by class:',
// //         error.response?.data?.message,
// //       )
// //     }

// //     // Filter students by class
// //     const filtered = allStudents.filter(
// //       (student) => student.class_id === Number(classId),
// //     )
// //     setFilteredStudents(filtered)
// //   }
// //   const handleStudentChange = async (e) => {
// //     const studentId = Number(e.target.value)
// //     const student = filteredStudents.find((s) => s.id === studentId)

// //     if (student) {
// //       setSelectedStudent(student)
// //       setSelectedCourseId(student.course_id) // sync course dropdown
// //       // setSelectedClassId(student.class_id)
// //       // Fetch classes for course if not already fetched
// //       if (!classes.length) {
// //         const res = await ApiEndpoints.getAllClassesByCourseId(
// //           student.course_id,
// //         )
// //         setClasses(res.data.data || [])
// //       }


// //       try {
// //         const res = await ApiEndpoints.getAllStudents({
// //           class_id: student.class_id,
// //           student_id: student.id,
// //         })
// //         const filteredStudents = (res.data.data || []).filter(
// //           (entry) => entry.student_id === student.id,
// //         )
      
// //         setSelectedStudent(filteredStudents)
// //       } catch (error) {
// //         console.error(
// //           'Error fetching student attendance:',
// //           error.response?.data?.message,
// //         )
// //       }
// //     }
// //   }

// //   const handlePrint = () => window.print();

// //   const convertDateToWords = (dateStr) => {
// //     if (!dateStr) return '';
// //     const date = new Date(dateStr);
// //     return `${date.getDate()} ${date.toLocaleString('default', { month: 'long' })} ${date.getFullYear()}`;
// //   };

// //   return (
// //     <div className="container mt-3 mb-4">
// //       {/* Dropdowns */}
// //       <Row className="g-2 align-items-end d-flex mt-3 flex-wrap">
// //         <Col md={3}>
// //           <Form.Group className="text-start fw-bold mb-0">
// //             <Form.Label>Select Course</Form.Label>
// //             <Typeahead
// //               id="course-select"
// //               labelKey="name"
// //               onChange={(selected) => {
// //                 const course = selected[0];
// //                 setSelectedCourseId(course ? course.id : null);
// //               }}
// //               options={courses}
// //               placeholder="Select Course"
// //               selected={courses.filter(c => c.id === selectedCourseId)}
// //             />
// //           </Form.Group>
// //         </Col>

// //         <Col md={3}>
// //           <Form.Group className="text-start fw-bold mb-0">
// //             <Form.Label>Select Class</Form.Label>
// //             <Typeahead
// //               id="class-select"
// //               labelKey="class_name"
// //                onChange={(selected) => {
// //                 const cls = selected[0]
// //                 if (cls) {
// //                   handleClassChange({ target: { value: cls.id } })
// //                 } else {
// //                   handleClassChange({ target: { value: '' } })
// //                 }
// //               }}
// //               options={classes}
// //               placeholder="Select Class"
// //               selected={classes.filter(
// //                 (cs) => cs.id === Number(selectedClassId),
// //               )}
// //             />
// //           </Form.Group>
// //         </Col>

// //         <Col md={3}>
// //           <Form.Group className="text-start fw-bold mb-0">
// //             <Form.Label>Select Student</Form.Label>
// //             <Typeahead
// //               id="student-select"
// //               labelKey={option => `${option.name} - ${option.admission_number || ''}`}
             
// //                 onChange={(selected) => {
// //                 const student = selected[0]
// //                 if (student) {
// //                   // Simulate event for your existing handler
// //                   handleStudentChange({ target: { value: student.id } })
// //                 } else {
// //                   // Clear selection
// //                   setSelectedStudent(null)
// //                 }
// //               }}
// //               onInputChange={(text) => {
// //                 // Optional: clear selected student when user types
// //                 if (text === '') {
// //                   setSelectedStudent(null)
// //                 }
// //               }}
// //               options={filteredStudents}
// //               placeholder="Select Student"
// //               selected={
// //                 selectedStudent
// //                   ? filteredStudents.filter((s) => s.id === selectedStudent.id)
// //                   : []
// //               }

// //             />
// //           </Form.Group>
// //         </Col>
// //       </Row>

// //       {/* Print Button */}
// //       {/* {selectedStudent && ( */}
// //         <div className="text-end mb-3">
// //           <button className="btn btn-success" onClick={handlePrint}>Print TC</button>
// //         </div>
// //       {/* )} */}

// //       {/* Certificate */}
// //       {/* {selectedStudent && ( */}
// //         <div className="certificate-container border p-4 bg-light">
// //           <div className="text-center mb-4">
// //             <h4>HOLY CHILD ENGLISH SCHOOL</h4>
// //             <p>(Affiliated to CBSE, New Delhi, No.230149)</p>
// //             <p>GOPALPUR, JAMUGURIHAT, SONITPUR, ASSAM-784180</p>
// //             <p>School Code-30138</p>
// //           </div>

// //           <div className="d-flex justify-content-between mb-4">
// //             <span>S1. No {tcData.serialNo}</span>
// //             <span>Date...... {tcData.date ? new Date(tcData.date).toLocaleDateString() : '______'}</span>
// //           </div>

// //           <div className="text-center mb-4">
// //             <h5>TRANSFER/SCHOOL LEAVING CERTIFICATE</h5>
// //           </div>

// //           <div className="mb-3">
// //             <p>This is to certify that Shri/Miss...... <strong>{tcData.studentName}</strong></p>
// //             <p>Son/Daughter of Shri...... <strong>{tcData.fatherName}</strong> and Smt...... <strong>{tcData.motherName}</strong> of</p>
// //             <p>Village/Town...... <strong>{tcData.villageTown}</strong> of District...... <strong>{tcData.district}</strong> State...... <strong>{tcData.state}</strong></p>
// //             <p>was admitted to the School on...... <strong>{tcData.admissionDate ? new Date(tcData.admissionDate).toLocaleDateString() : '______'}</strong> and left on...... <strong>{tcData.leavingDate ? new Date(tcData.leavingDate).toLocaleDateString() : '______'}</strong></p>
// //             <p>He/ She was reading in class ...... <strong>{tcData.currentClass}</strong> and passed to class/detained in Class...... <strong>{tcData.nextClass}</strong>.</p>
// //           </div>

// //           <div className="mb-3">
// //             <p>He/She {tcData.examResult} in the {tcData.examType} held in...... <strong>{tcData.examYear}</strong> under the Central board of Secondary Education, New Delhi.</p>
// //           </div>

// //           <div className="mb-3">
// //             <p>All the dues are cleared.</p>
// //           </div>

// //           <div className="mb-3">
// //             <p>His/Her date of birth according to our Admission Register is ...... <strong>{tcData.dob ? new Date(tcData.dob).toLocaleDateString() : '______'}</strong></p>
// //             <p>(in words) ...... <strong>{tcData.dob ? convertDateToWords(tcData.dob) : '______'}</strong></p>
// //           </div>

// //           <div className="mb-3">
// //             <p>His/her character and conduct were {tcData.conduct}.</p>
// //           </div>

// //           <div className="mb-3">
// //             <p>Reasons for leaving School: -</p>
// //             <p>1. {tcData.reason}</p>
// //           </div>

// //           <div className="d-flex justify-content-between mt-4">
// //             <div>
// //               <p>Date:...... <strong>{tcData.date ? new Date(tcData.date).toLocaleDateString() : '______'}</strong></p>
// //               <p>Place:...... <strong>{tcData.place}</strong></p>
// //             </div>
// //             <div className="text-center">
// //               <p>Principal</p>
// //               <p>Holy Child English School</p>
// //               <p>Gopalpur, Jamugurihat</p>
// //             </div>
// //           </div>
// //         </div>
// //       {/* )} */}

// //       <style>{`
// //         .certificate-container {
// //           font-family: 'Times New Roman', serif;
// //           line-height: 1.4;
// //           max-width: 100%;
// //           margin: auto;
// //           padding: 20px;
// //         }
// //         @media print {
// //           body * { visibility: hidden; }
// //           .certificate-container, .certificate-container * { visibility: visible; }
// //         }
// //       `}</style>
// //     </div>
// //   );
// // };

// // export default StudentTC;


// import React, { useState, useEffect } from 'react'
// import { Button, Col, Form, Row } from 'react-bootstrap'
// import 'bootstrap/dist/css/bootstrap.min.css'
// import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
// import toast from 'react-hot-toast'
// import axios from 'axios'
// import Cookies from 'js-cookie'
// import { FaSyncAlt } from 'react-icons/fa'
// import { useNavigate, useParams } from 'react-router-dom'
// import { Typeahead } from 'react-bootstrap-typeahead'

// export default function StudentTC() {
//   const [marginLeft, setMarginLeft] = useState(
//     window.innerWidth >= 992 ? '300px' : '0px',
//   )

//   useEffect(() => {
//     const handleResize = () => {
//       setMarginLeft(window.innerWidth >= 992 ? '270px' : '0px')
//     }

//     window.addEventListener('resize', handleResize)
//     return () => window.removeEventListener('resize', handleResize)
//   }, [])

//   return (
//     <div style={{ marginLeft }}>
//       <div
//         className="container-fluid p-0 "
//         style={{ marginTop: window.innerWidth < 992 ? '55px' : '-12px' }}
//       >
//         <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
//           <h2 className="m-0">
//             {/* {selectedStudent ? ( */}
//               <>
//                 View{' '}
//                 <span className="text-warning">
//                   {/* {selectedStudent.name.charAt(0).toUpperCase() +
//                     selectedStudent.name.slice(1).toLowerCase()} */}
//                 </span>
//                 's Attendance
//               </>
//             {/* ) : ( */}
//               'GENERATE TRANSFER CERTIFICATE'
//             {/* )} */}
//           </h2>
//         </div>
//       </div>

//       <Row className="g-2 align-items-end d-flex mt-3 flex-wrap">
//         <Col md={3}>
//           <Form.Group className="text-start fw-bold mb-0">
//             <Form.Label>Select Course</Form.Label>
//             <Form.Select value={selectedCourseId} onChange={handleCourseChange}>
//               <option>Select Course</option>
//               {courses.map((course) => (
//                 <option key={course.id} value={course.id}>
//                   {course.name}
//                 </option>
//               ))}
//             </Form.Select>
//             <Typeahead
//               id="course-select"
//               labelKey="name"
//               // onChange={(selected) => {
//               //   const course = selected[0]
//               //   if (course) {
//               //     handleCourseChange({ target: { value: course.id } })
//               //   } else {
//               //     handleCourseChange({ target: { value: '' } })
//               //   }
//               // }}
//               // options={courses}
//               // placeholder="Select Course"
//               // selected={courses.filter(
//               //   (cs) => cs.id === Number(selectedCourseId),
//               // )}
//             />
//           </Form.Group>
//         </Col>
//         <Col md={3}>
//           <Form.Group className="text-start fw-bold mb-0">
//             <Form.Label>Select Class</Form.Label>
//             {/* <Form.Select value={selectedClassId} onChange={handleClassChange}>
//               <option>Select Class</option>
//               {classes.map((cls) => (
//                 <option key={cls.id} value={cls.id}>
//                   {cls.class_name}
//                 </option>
//               ))}
//             </Form.Select> */}
//             <Typeahead
//               id="class-select"
//               labelKey="class_name"
//               // onChange={(selected) => {
//               //   const cls = selected[0]
//               //   if (cls) {
//               //     handleClassChange({ target: { value: cls.id } })
//               //   } else {
//               //     handleClassChange({ target: { value: '' } })
//               //   }
//               // }}
//               // options={classes}
//               // placeholder="Select Class"
//               // selected={classes.filter(
//               //   (cs) => cs.id === Number(selectedClassId),
//               // )}
//             />
//           </Form.Group>
//         </Col>
//         <Col md={3}>
//           <Form.Group className="text-start fw-bold mb-0">
//             <Form.Label>Select Student</Form.Label>
//             {/* <Form.Select
//               value={selectedStudent?.id}
//               onChange={handleStudentChange}
//             >
//               <option>Select Student</option>

//               {filteredStudents.map((student) => (
//                 <option key={student.id} value={student.id}>
//                   {student.name}
//                 </option>
//               ))}
//             </Form.Select> */}
//             <Typeahead
//               id="student-select"
//               labelKey={(option) =>
//                 `${option.name} - ${option.admission_number}`
//               }
//               // onChange={(selected) => {
//               //   const student = selected[0]
//               //   if (student) {
//               //     // Simulate event for your existing handler
//               //     handleStudentChange({ target: { value: student.id } })
//               //   } else {
//               //     // Clear selection
//               //     setSelectedStudent(null)
//               //   }
//               // }}
//               // onInputChange={(text) => {
//               //   // Optional: clear selected student when user types
//               //   if (text === '') {
//               //     setSelectedStudent(null)
//               //   }
//               // }}
//               // options={filteredStudents}
//               // placeholder="Select Student"
//               // selected={
//               //   selectedStudent
//               //     ? filteredStudents.filter((s) => s.id === selectedStudent.id)
//               //     : []
//               // }
//             />
//           </Form.Group>
//         </Col>
//         <Col className="d-flex justify-content-md-end justify-content-start">
//           <Button
//             variant="outline-primary"
//             // onClick={handleRefresh}
//             title="Refresh"
//           >
//             <FaSyncAlt /> Refresh
//           </Button>
//         </Col>
//       </Row>
//       {/* {openTable && ( */}
//         <>
         
         
//     <div className="certificate-container border p-4 bg-light mt-4">
//       <div className="text-center mb-4">
//         <h4>HOLY CHILD ENGLISH SCHOOL</h4>
//         <p>(Affiliated to CBSE, New Delhi, No.230149)</p>
//         <p>GOPALPUR, JAMUGURIHAT, SONITPUR, ASSAM-784180</p>
//         <p>School Code-30138</p>
//       </div>

//       <div className="d-flex justify-content-between mb-4">
//         <span>S1. No...... 
//           {/* {tcData.serialNo} */}
//           </span>
//         <span>Date...... 
//           {/* {tcData.date ? new Date(tcData.date).toLocaleDateString() : '______'} */}
//           </span>
//       </div>

//       <div className="text-center mb-4">
//         <h5>TRANSFER/SCHOOL LEAVING CERTIFICATE</h5>
//       </div>

//       <div className="mb-3">
//         <p>This is to certify that Shri/Miss...... <strong>
//           {/* {tcData.studentName} */}
//           </strong></p>
//         <p>Son/Daughter of Shri...... <strong>
//           {/* {tcData.fatherName} */}
//           </strong> and Smt...... <strong>
//             {/* {tcData.motherName} */}
//             </strong> of</p>
//         <p>Village/Town...... <strong>
//           {/* {tcData.villageTown} */}
//           </strong> of District...... <strong>
//             {/* {tcData.district} */}
//             </strong> State...... <strong>
//               {/* {tcData.state} */}
//               </strong></p>
//         <p>was admitted to the School on...... <strong>
//           {/* {tcData.admissionDate ? new Date(tcData.admissionDate).toLocaleDateString() : '______'} */}
//           </strong> and left on...... <strong>
//             {/* {tcData.leavingDate ? new Date(tcData.leavingDate).toLocaleDateString() : '______'} */}
//             </strong></p>
//         <p>He/ She was reading in class ...... <strong>
//           {/* {tcData.currentClass} */}
//           {/* </strong> and passed to class/detained in Class...... <strong>{tcData.nextClass} */}
//             </strong>.</p>
//       </div>

//       <div className="mb-3">
//         <p>He/She 
//           {/* {tcData.examResult} */}
//            in the 
//            {/* {tcData.examType}  */}
//            held in...... <strong>
//             {/* {tcData.examYear} */}
//             </strong> under the Central board of Secondary Education, New Delhi.</p>
//       </div>

//       <div className="mb-3">
//         <p>All the dues are cleared.</p>
//       </div>

//       <div className="mb-3">
//         <p>His/Her date of birth according to our Admission Register is ...... <strong>
//           {/* {tcData.dob ? new Date(tcData.dob).toLocaleDateString() : '______'} */}
          
//           </strong></p>
//         <p>(in words) ...... <strong>
//           {/* {tcData.dob ? convertDateToWords(tcData.dob) : '______'} */}
//           </strong></p>
//       </div>

//       <div className="mb-3">
//         <p>His/her character and conduct were
//            {/* {tcData.conduct} */}
//            .</p>
//       </div>

//       <div className="mb-3">
//         <p>Reasons for leaving School: -</p>
//         <p>1.
//            {/* {tcData.reason} */}
//            </p>
//       </div>

//       <div className="d-flex justify-content-between mt-4">
//         <div>
//           <p>Date:...... <strong>
//             {/* {tcData.date ? new Date(tcData.date).toLocaleDateString() : '______'} */}
//             </strong></p>
//           <p>Place:...... <strong>
//             {/* {tcData.place} */}
//             </strong></p>
//         </div>
//         <div className="text-center">
//           <p>Principal</p>
//           <p>Holy Child English School</p>
//           <p>Gopalpur, Jamugurihat</p>
//         </div>
//       </div>
//     </div>
//   {/* )} */}

//   <style>{`
//     .certificate-container {
//       font-family: 'Times New Roman', serif;
//       line-height: 1.4;
//       max-width: 100%;
//       margin: auto;
//       padding: 20px;
//     }
//     @media print {
//       body * { visibility: hidden; }
//       .certificate-container, .certificate-container * { visibility: visible; }
//     }
//   `}</style>

//         </>
//       {/* )} */}
//     </div>
//   )
// }


import React, { useEffect, useState } from 'react';
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints';
import toast from 'react-hot-toast';
import Cookies from 'js-cookie'
import axios from 'axios';

const StudentTC = () => {
    const [marginLeft, setMarginLeft] = useState(
      window.innerWidth >= 992 ? '300px' : '0px',
    )
    
      useEffect(() => {
        const handleResize = () => {
          setMarginLeft(window.innerWidth >= 992 ? '270px' : '0px')
        }
    
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
      }, [])
  const [courses, setCourses] = useState([]);
  const [classes, setClasses] = useState([]);
  const [students, setStudents] = useState([]);
  
  // State for selected values
  const [selectedCourse, setSelectedCourse] = useState('');
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedStudent, setSelectedStudent] = useState('');
  const [selectedStudentWithData, setSelectedStudentWithData] = useState('');
  const [allStudents, setAllStudents] = useState([])
  const [institutes, setInstitutes] = useState([]);
  const [instituteName, setInstitutename] = useState()
  const [instituteData, setInstituteData] = useState()

    useEffect(() => {
      const storedInstituteName = Cookies.get('institute_name')
      // const storedInstituteId = Cookies.get('institute_id')
  
      if (storedInstituteName) {
        console.log('Institute name:', storedInstituteName)
        setInstitutename(storedInstituteName)
      }
    }, [])

useEffect(() => {
  ApiEndpoints.getAllInstitutes().then((res) => {
    if (Array.isArray(res.data.data)) {
      const allInstitutes = res.data.data;
      setInstitutes(allInstitutes);

      // if you have institute_id from cookie or student
      const instituteId = Cookies.get("institute_id");  // or selectedStudent?.institute_id

      if (instituteId) {
        const matchedInstitute = allInstitutes.find(
          (inst) => inst.institute_id === Number(instituteId)
        );
        console.log("ADDRESS:", matchedInstitute?.address);
        setInstituteData(matchedInstitute)
      }
    }
  });
}, []);


 


  // State for TC data
  const [tcData, setTcData] = useState({
    serialNo: '',
    date: new Date().toISOString().split('T')[0],
    studentName: '',
    fatherName: '',
    motherName: '',
    villageTown: '',
    district: 'Sonitpur',
    state: 'Assam',
    admissionDate: '',
    leavingDate: '',
    currentClass: '',
    nextClass: '',
    examType: '',
    examYear: '',
    examResult: 'passed',
    dob: '',
    dobWords: '',
    conduct: 'satisfactory',
    reason: 'Unavoidable change of residence',
    place: 'Gopalpur, Jamugurihat'
  });



  useEffect(() => {
    ApiEndpoints.getAllCourses()
      .then((res) => setCourses(res.data.data))
      .catch(console.error)
  }, [])


useEffect(() => {
  const fetchClasses = async () => {
    if (!selectedCourse) return;

    try {
      console.log("COURSE ID:", selectedCourse);
      const res = await ApiEndpoints.getAllClassesByCourseId(parseInt(selectedCourse));
      console.log("Classes are: ", res.data.data || [])
      const classList = res.data.data || [];

      setClasses(classList);
      setSelectedClass('');
      setStudents([]);
      setSelectedStudent('');
    } catch (error) {
      console.error(error);
      toast.error('Error fetching classes.');
    }
  };

  fetchClasses();
}, [selectedCourse]);

useEffect(() => {
  const institueId = Cookies.get('institute_id')
  const userCookie = Cookies.get('user')
  let token = null

  if (userCookie) {
    try {
      const user = JSON.parse(userCookie)
      token = user.token
    } catch (err) {
      console.error(' Failed to parse user cookie', err)
    }
  } else {
    console.warn('user cookie not found')
  }

  const fetchStudentbyClass = async () => {
    if (!selectedClass) return

    try {
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'institute-Id': Number(institueId),
      }

      const response = await axios.get(
        BASE_URL+`/get/student/by-class?class_id=${parseInt(selectedClass)}`,
        { headers },
      )

      console.log('Students response: ', response.data.data)

      // ✅ Correct state update
      setStudents(response.data.data || [])
    } catch (error) {
      toast.error(error.response?.data?.message || 'Something went wrong')
    }
  }

  fetchStudentbyClass()
}, [selectedClass]) // ✅ run whenever selectedClass changes

// Fetch full data of selected student

useEffect(() => {
  const institueId = Cookies.get('institute_id')
  const userCookie = Cookies.get('user')
  let token = null

  if (userCookie) {
    try {
      const user = JSON.parse(userCookie)
      token = user.token
    } catch (err) {
      console.error(' Failed to parse user cookie', err)
    }
  } else {
    console.warn('user cookie not found')
  }

  const fetchAllStudents = async () => {
    if (!students) return

    try {
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'institute-Id': Number(institueId),
      }

      const response = await axios.get(
        BASE_URL+`/student/all`,
        { headers },
      )

      console.log('Students response with all data: ', response.data.data)

      // ✅ Correct state update
      setAllStudents(response.data.data || [])
    } catch (error) {
      toast.error(error.response?.data?.message || 'Something went wrong')
    }
  }

  fetchAllStudents()
}, [selectedClass]) // ✅ run whenever selectedClass changes


const handleStudentChange = (studentId) => {
  // find full data from allStudents by matching id
  const fullData = allStudents.find(std => std.id === studentId);
  setSelectedStudent(fullData || null);
  console.log("FULL DATA: ", fullData)
};


  // Update TC data when student is selected
  useEffect(() => {
    if (selectedStudent) {
      const student = students.find(s => s.id === parseInt(selectedStudent));
      if (student) {
        setTcData(prev => ({
          ...prev,
          studentName: student.name,
          fatherName: student.father,
          motherName: student.mother,
          villageTown: student.address,
          dob: student.dob,
          currentClass: classes.find(c => c.id === parseInt(selectedClass))?.name || '',
          nextClass: determineNextClass(classes.find(c => c.id === parseInt(selectedClass))?.name || ''),
          admissionDate: '2018-04-01', // This would come from API
          leavingDate: new Date().toISOString().split('T')[0],
          serialNo: generateSerialNo()
        }));
      }
    }
  }, [selectedStudent, students, classes, selectedClass]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTcData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePrint = () => {
    window.print();
  };

  // Helper functions
  const generateSerialNo = () => {
    return Math.floor(1000 + Math.random() * 9000).toString();
  };

  const determineNextClass = (currentClass) => {
    const classMap = {
      'Class X': 'Class XI',
      'Class XI': 'Class XII',
      'Class XII': 'Graduated'
    };
    return classMap[currentClass] || 'Next Class';
  };

  const convertDateToWords = (dateStr) => {
    if (!dateStr) return '';
    
    const date = new Date(dateStr);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    
    return `${day} ${month} ${year}`;
  };

  return (
     <div 
     style={{ marginLeft }}
     >
      <div
        className="container-fluid p-0 "
        style={{ marginTop: window.innerWidth < 992 ? '55px' : '-12px' }}
      >
        {/* <div className="col-lg-10"> */}
          {/* <div className="card shadow-sm mb-3"> */}
             <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2 className="m-0">Generate TC</h2>
              <button className="btn btn-light btn-sm" onClick={handlePrint}>
                <i className="fas fa-print me-1"></i> Print TC
              </button>
            </div>
            <div className="card-body p-3">
             <div className="row mb-3 text-start">
                <div className="col-md-4">
                  <div className="form-group mb-2">
                    <label className="form-label mb-0 fw-bold">Select Course</label>
                    <select 
                      className="form-select" 
                      value={selectedCourse}
                      onChange={(e) => setSelectedCourse(e.target.value)}
                    >
                      <option value="">Select Course</option>
                      {courses.map(course => (
                        <option key={course.id} value={course.id}>{course.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
                
                <div className="col-md-4">
                  <div className="form-group mb-2">
                    <label className="form-label mb-0 fw-bold">Select Class</label>
                    <select 
                      className="form-select" 
                      value={selectedClass}
                      onChange={(e) => setSelectedClass(e.target.value)}
                      disabled={!selectedCourse}
                    >
                      <option value="">Select Class</option>
                      {classes.map(cls => (
                        <option key={cls.id} value={cls.id}>{cls.class_name}</option>
                      ))}
                    </select>
                  </div>
                </div>
                
                <div className="col-md-4">
                  <div className="form-group mb-2">
                    <label className="form-label mb-0 fw-bold">Select Student</label>
                    <select 
                      className="form-select" 
                      value={students.name}
                      onChange={(e) => handleStudentChange(Number(e.target.value))}
                      disabled={!selectedClass}
                    >
                      <option value="">Select Student</option>
                      {students.map(student => (
                        <option key={student.id} value={student.id}>{student.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              
              {/* {selectedStudent && (
                <>
                  <hr />
                  <p className="mb-2 fw-semibold text-info text-decoration-underline" style={{fontSize:"1.3rem"}}>Review and edit TC details if needed</p>
                  
                  <div className="row mb-2 text-start">
                    <div className="col-md-3">
                      <div className="form-group mb-2">
                        <label className="form-label mb-0">Serial No</label>
                        <input 
                          type="text" 
                          className="form-control form-control-sm" 
                          name="serialNo"
                          value={tcData.serialNo}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div className="form-group mb-2">
                        <label className="form-label mb-0">Date</label>
                        <input 
                          type="date" 
                          className="form-control form-control-sm" 
                          name="date"
                          value={tcData.date}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group mb-2">
                        <label className="form-label mb-0">Place</label>
                        <input 
                          type="text" 
                          className="form-control form-control-sm" 
                          name="place"
                          value={tcData.place}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row mb-2 text-start">
                    <div className="col-md-8">
                      <div className="form-group mb-2">
                        <label className="form-label mb-0">Student Name</label>
                        <input 
                          type="text" 
                          className="form-control form-control-sm" 
                          name="studentName"
                          value={tcData.studentName}
                          onChange={handleChange}
                          placeholder="Shri/Miss"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group mb-2">
                        <label className="form-label mb-0">Date of Birth</label>
                        <input 
                          type="date" 
                          className="form-control form-control-sm" 
                          name="dob"
                          value={tcData.dob}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row mb-2 text-start">
                    <div className="col-md-6">
                      <div className="form-group mb-2">
                        <label className="form-label mb-0">Father's Name</label>
                        <input 
                          type="text" 
                          className="form-control form-control-sm" 
                          name="fatherName"
                          value={tcData.fatherName}
                          onChange={handleChange}
                          placeholder="Shri"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-2">
                        <label className="form-label mb-0">Mother's Name</label>
                        <input 
                          type="text" 
                          className="form-control form-control-sm" 
                          name="motherName"
                          value={tcData.motherName}
                          onChange={handleChange}
                          placeholder="Smt."
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row mb-2 text-start">
                    <div className="col-md-4">
                      <div className="form-group mb-2">
                        <label className="form-label mb-0">Village/Town</label>
                        <input 
                          type="text" 
                          className="form-control form-control-sm" 
                          name="villageTown"
                          value={tcData.villageTown}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group mb-2">
                        <label className="form-label mb-0">District</label>
                        <input 
                          type="text" 
                          className="form-control form-control-sm" 
                          name="district"
                          value={tcData.district}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group mb-2">
                        <label className="form-label mb-0">State</label>
                        <input 
                          type="text" 
                          className="form-control form-control-sm" 
                          name="state"
                          value={tcData.state}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row mb-2 text-start">
                    <div className="col-md-4">
                      <div className="form-group mb-2">
                        <label className="form-label mb-0">Admission Date</label>
                        <input 
                          type="date" 
                          className="form-control form-control-sm" 
                          name="admissionDate"
                          value={tcData.admissionDate}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group mb-2">
                        <label className="form-label mb-0">Leaving Date</label>
                        <input 
                          type="date" 
                          className="form-control form-control-sm" 
                          name="leavingDate"
                          value={tcData.leavingDate}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group mb-2">
                        <label className="form-label mb-0">Current Class</label>
                        <input 
                          type="text" 
                          className="form-control form-control-sm" 
                          name="currentClass"
                          value={tcData.currentClass}
                          onChange={handleChange}
                          placeholder="e.g., X"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row mb-2 text-start">
                    <div className="col-md-4">
                      <div className="form-group mb-2">
                        <label className="form-label mb-0">Next Class/Detained</label>
                        <input 
                          type="text" 
                          className="form-control form-control-sm" 
                          name="nextClass"
                          value={tcData.nextClass}
                          onChange={handleChange}
                          placeholder="e.g., XI or Detained"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group mb-2">
                        <label className="form-label mb-0">Exam Type</label>
                        <select 
                          className="form-select form-select-sm" 
                          name="examType"
                          value={tcData.examType}
                          onChange={handleChange}
                        >
                          <option value="">Select Exam</option>
                          <option value="All India Senior Secondary School Examination">Senior Secondary</option>
                          <option value="All India Secondary School Examination">Secondary</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group mb-2">
                        <label className="form-label mb-0">Exam Year</label>
                        <input 
                          type="number" 
                          className="form-control form-control-sm" 
                          name="examYear"
                          value={tcData.examYear}
                          onChange={handleChange}
                          min="2000"
                          max="2030"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row mb-2 text-start">
                    <div className="col-md-4">
                      <div className="form-group mb-2">
                        <label className="form-label mb-0">Exam Result</label>
                        <select 
                          className="form-select form-select-sm" 
                          name="examResult"
                          value={tcData.examResult}
                          onChange={handleChange}
                        >
                          <option value="passed">Passed</option>
                          <option value="failed">Failed</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group mb-2">
                        <label className="form-label mb-0">Conduct</label>
                        <select 
                          className="form-select form-select-sm" 
                          name="conduct"
                          value={tcData.conduct}
                          onChange={handleChange}
                        >
                          <option value="satisfactory">Satisfactory</option>
                          <option value="not satisfactory">Not Satisfactory</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group mb-2">
                        <label className="form-label mb-0">Reason for Leaving</label>
                        <select 
                          className="form-select form-select-sm" 
                          name="reason"
                          value={tcData.reason}
                          onChange={handleChange}
                        >
                          <option value="Unavoidable change of residence">Change of residence</option>
                          <option value="Ill Health">Ill Health</option>
                          <option value="Completion of School Course">Course Completion</option>
                          <option value="Minor reasons">Minor reasons</option>
                          <option value="Guardian option">Guardian option</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </>
              )} */}
            </div>
          {/* </div> */}

          {/* Certificate Preview */}
          {selectedStudent && (
            <div className="certificate-container border p-4 bg-white" id="tc-certificate">
              <div className="text-center mb-5">
                <h4 className="mb-0 fw-bold text-danger">{instituteName}</h4>
                {/* <p className="mb-0">(Affiliated to CBSE, New Delhi, No.230149)</p> */}
                 <p className="mb-0 fw-semibold text-muted">{instituteData?.address}-{instituteData?.pincode}</p>
              </div>

              <div className="text-start mt-4">
                <div className="d-flex justify-content-between mb-3">
                  <span>Sl. No.: <strong>{tcData.serialNo || '______'}</strong></span>
                  <span>Date: <strong>{tcData.date ? new Date(tcData.date).toLocaleDateString() : '______'}</strong></span>
                </div>

                <div className="text-center mb-3">
                <img 
                  src="/tta_logo.jpg" 
                  alt="Logo" 
                  style={{height:120, marginBottom:"2rem" }} 
                />
                  <h5 className="mb-1 fw-bold">TRANSFER / SCHOOL LEAVING CERTIFICATE</h5>
                </div>

                <div className="mb-3" style={{marginTop:"3rem"}}>
                  <p style={{ display: "flex", alignItems: "center" }}>This is to certify that Shri/Miss 
                    {/* <span className="line">{selectedStudent.name  || "\u00A0"}</span> */}
                       <span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}>
                        {selectedStudent.name || "\u00A0"}
                      </span> 
                    </p>
                  <p style={{ display: "flex", alignItems: "center" }}>Son/Daughter of Shri/Late <span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}>{selectedStudent.father_name || '\u00A0'}</span> of</p>
                   
                  <p style={{ display: "flex", alignItems: "center" }}>Village/Town <span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}>{selectedStudent.address  || "\u00A0"}</span></p>
                  <p style={{ display: "flex", alignItems: "center" }}>was admitted to the School on <span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}className="line">{selectedStudent.admission_date ? new Date(selectedStudent.admission_date).toLocaleDateString() : '________________'}</span> 
                    and left on <span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}className="">{selectedStudent.leavingDate ? new Date(selectedStudent.leavingDate).toLocaleDateString() : '\u00A0'}</span></p>
                  <p style={{ display: "flex", alignItems: "center" }}>He/She was reading in class <span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}className="">{selectedStudent.currentClass  || "\u00A0"}</span> 
                    and promoted/detained to class <span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}className="">{selectedStudent.nextClass  || "\u00A0"}</span></p>
                </div>

                <div className="mb-3">
                  <p style={{ display: "flex", alignItems: "center" }}>He/She {selectedStudent.examResult === 'passed' ? 'passed' : 'failed'} in the 
                    <span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}className="">{tcData.examType  || "\u00A0"}</span> held in 
                    <span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}className="">{tcData.examYear  || "\u00A0"}</span> under the Central Board of Secondary Education, New Delhi.</p>
                </div>

                <div className="mb-3">
                  <p style={{ display: "flex", alignItems: "center" }}>All the dues are cleared.</p>
                </div>

                <div className="mb-3">
                  <p style={{ display: "flex", alignItems: "center" }}>His/Her date of birth according to our Admission Register is 
                    <span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}className="">{tcData.dob ? new Date(tcData.dob).toLocaleDateString() : '\u00A0'}</span></p>

                  <p style={{ display: "flex", alignItems: "center" }}>(in words) <span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}className="">{tcData.dob ? convertDateToWords(tcData.dob) : '\u00A0'}</span>
                  </p>
                </div>

                <div className="mb-3">
                    <p style={{ display: "flex", alignItems: "center" }}>His/Her character and conduct were 
                    <span style={{ flex: 1, borderBottom: "1px solid black", marginLeft: "8px", fontWeight:"bold", justifyContent:"center", display:"flex" }}className="">{ "\u00A0"}</span>.</p>
                </div>

                <div className="mb-3">
                  <p className='fw-bold'>Reasons for leaving School: -</p>
                  <p>1. Unavoidable changes of residence.</p>
                  <p>2. Ill Health.</p>
                  <p>3. Completion of School Course.</p>
                  <p>4. Minor reasons.</p>
                  <p>5. Guardian options.</p>
                </div>

                <div className="d-flex justify-content-between ">
                  <div className=''>
                  <p>Date: ________________</p>

                  <p>Place: ________________</p>
                  </div>
                  <div className="text-center">
                    <p>Principal</p>
                    <p>{instituteName}</p>
                    <p>{instituteData?.address}</p>
                  </div>
                </div>
              </div>

            </div>
          )}
        </div>
      {/* </div> */}

      <style>{`
        @media print {
          body * {
            visibility: hidden;
          }
          #tc-certificate, #tc-certificate * {
            visibility: visible;
          }
          #tc-certificate {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            padding: 15mm;
            margin: 0;
            background-color: white;
            font-size: 14px;
            line-height: 1.4;
          }
          .card, .form-control, .btn {
            display: none !important;
          }
        }
        
        .certificate-container {
          font-family: 'Times New Roman', serif;
          font-size: 15px;
          line-height: 1.4;
        }
        
        .form-group {
          margin-bottom: 0.5rem;
        }
        
        .form-label {
          font-weight: 500;
          margin-bottom: 0.2rem;
          font-size: 13px;
        }
        
        .form-control-sm {
          height: calc(1.5em + 0.5rem);
          padding: 0.25rem 0.5rem;
          font-size: 0.875rem;
        }
        
        .form-select-sm {
          height: calc(1.5em + 0.5rem);
          padding: 0.25rem 0.5rem;
          font-size: 0.875rem;
        }
          .certificate-body p {
  text-align: justify;
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 1.8; /* makes lines larger/equal height */
}
  .certificate-body {
  width: 100%;
  font-size: 16px;
  line-height: 1.8; /* make lines evenly spaced */
}

/* Make spans stretch full width inline */
.full-line {
  display: inline-block; /* inline-block works better inside <p> */
  width: calc(100% - 10px); /* leave small padding */
  border-bottom: 1px solid #000;
  text-align: left;
  margin-left: 5px;
  padding: 0 5px;
  white-space: nowrap; /* prevents breaking the line */
}

/* For print A4 fit */
@media print {
  #tc-certificate {
    width: 210mm;
    min-height: 297mm;
    padding: 15mm;
    margin: 0 auto;
    box-sizing: border-box;
  }
}



/* underline effect for blanks */
.line {
  display: inline-block;
  min-width: 180px;   /* adjust length of each blank */
  border-bottom: 1px solid #000;
  text-align: center;
  padding: 0 5px;
}

      `}</style>
    </div>
  );
};

export default StudentTC;